
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--ig-avatar-background, var(--ig-gray-200));--border-radius: var(--ig-avatar-border-radius, 0.25rem);--ig-theme: bootstrap;--ig-theme-variant: dark}`;
  